export enum EOverlay {
    none = "none",
    loading = "loading",
    "menu-mobile" = "menu-mobile",
    newsletter = "newsletter",
    loginForm = "loginForm",
    loginSuccessful = "loginSuccessful",
    registerForm = "registerForm",
    passwordForgotten = "passwordForgotten",
    thpOrder = "thpOrder",
    csvUpload = "csvUpload",
    excelUpload = "excelUpload",
    productInfo = "productInfo",
    priceRequest = "priceRequest",
    itemAddedToCart = "itemAddedToCart",
    itemsAddedToCart = "itemsAddedToCart",
    reorderItemAddedToCart = "reorderItemAddedToCart",
    reorderItemsAddedToCart = "reorderItemsAddedToCart",
    shipping = "shipping",
    molarmass = "molarmass",
    unitconverter = "unitconverter",
    periodictable = "periodictable",
    ppmtomgl = "ppmtomgl",
}

export const OverlaysConfig: IOverlaysConfig = {
    loginForm: { fragment: "login" },
    registerForm: { fragment: "register" },
    molarmass: { fragment: "molarmass" },
    unitconverter: { fragment: "unitconverter" },
    periodictable: { fragment: "periodictable" },
    ppmtomgl: { fragment: "ppmtomgl" },
};

export interface IOverlay {
    handle: EOverlay;
    fragment: string;
    obj?: any;
}

export type IOverlaysConfig = {
    [key in EOverlay]?: IOverlayConfig;
};

export interface IOverlayConfig {
    fragment: string;
}
